import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { B as Button } from '../Button/Button-C6bVESu6.js';
import { u as useButtonGroupContext } from './ButtonGroupContext-Cv5DXHcj.js';
import { a as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';
import { K as KEYBOARD_KEYNAMES } from '../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-AmBipDtf-AmBipDtf.js';

const transparentStyle = /*#__PURE__*/css([":hover{background-color:", ";}"], ({
  theme
}) => theme.button.backgroundColor.transparent.active);
const smallStyle = /*#__PURE__*/css(["padding-inline-start:", ";padding-inline-end:", ";"], ({
  theme
}) => theme.spacing.xsmall.default, ({
  theme
}) => theme.spacing.xsmall.default);
const StyledButton = /*#__PURE__*/styled(Button).withConfig({
  componentId: "sc-storm-ui-40018895__sc-h8v7ib-0"
})(["font-weight:", ";margin:0;&&&{border-radius:", ";border:none;box-shadow:none;", " ", " :disabled{color:", ";background-color:", ";:hover{color:", ";background-color:", ";}}}"], ({
  theme
}) => theme.font.weight.regular, ({
  theme
}) => theme.border.radius.round, ({
  small
}) => small && smallStyle, ({
  variant
}) => variant === 'transparent' && transparentStyle, ({
  theme,
  variant
}) => theme.text.color[variant === 'transparent' ? 'unavailable' : 'inverted'], ({
  theme,
  variant
}) => theme.buttonGroup.backgroundColor.unavailable[variant === 'transparent' ? 'unselected' : 'selected'], ({
  theme,
  variant
}) => theme.text.color[variant === 'transparent' ? 'unavailable' : 'inverted'], ({
  theme,
  variant
}) => theme.buttonGroup.backgroundColor.unavailable[variant === 'transparent' ? 'unselected' : 'selected']);
const ButtonGroupItem = ({
  inputRef = noop,
  disabled = false,
  value,
  children,
  taktId,
  taktValue,
  tabIndex,
  ...rest
}) => {
  const {
    name,
    small = false,
    selectedValue,
    onChange = noop
  } = useButtonGroupContext();
  const isChecked = selectedValue === value;
  const id = `${name}-${value}`;
  const handleKeyUp = event => {
    const {
      key
    } = event;
    if (key === KEYBOARD_KEYNAMES.ENTER || key === KEYBOARD_KEYNAMES.SPACE) {
      onChange(value, event);
      event.preventDefault();
    }
  };
  const handleChange = event => {
    if (onChange) {
      onChange(value, event);
    }
  };
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('button-group-item')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(StyledButton, _extends({}, getDataTaktAttributes(), rest, {
    variant: isChecked ? 'primary' : 'transparent',
    type: "button",
    id: id,
    role: "radio",
    "aria-checked": isChecked,
    $isChecked: isChecked,
    buttonRef: inputRef,
    name: name,
    small: small,
    onClick: handleChange,
    onKeyUp: handleKeyUp,
    value: value,
    disabled: disabled,
    tabIndex: tabIndex
  }), children));
};

export { ButtonGroupItem as B };
//# sourceMappingURL=ButtonGroupItem-CIIyqFJg.js.map
